(() => {
  document.addEventListener('click', (event) => {
    const thumbnail = event.target.closest('[data-product-gallery-select]');
    if (thumbnail) {
      const mainImage = document.querySelector('[data-gallery-main]');
      if (mainImage) {
        const index = thumbnail.dataset.index;
        const selectedImage = thumbnail.dataset.image;
        const selectedAlt = thumbnail.dataset.alt || '';
        mainImage.src = selectedImage;
        mainImage.alt = selectedAlt;
        mainImage.dataset.selectedImage = selectedImage;
        mainImage.dataset.selectedAlt = selectedAlt;
        document.querySelectorAll('[data-gallery-thumb]').forEach((item) => item.setAttribute('aria-current', item === thumbnail ? 'true' : 'false'));
        document.querySelectorAll('[data-gallery-mobile-thumb]').forEach((item) => item.setAttribute('aria-current', item.dataset.index === index ? 'true' : 'false'));
      }
      return;
    }
    const mobileThumbnail = event.target.closest('[data-gallery-mobile-thumb]');
    if (mobileThumbnail) {
      const mainImage = document.querySelector('[data-gallery-main]');
      if (mainImage) {
        const index = mobileThumbnail.dataset.index;
        const selectedImage = mobileThumbnail.dataset.image;
        const selectedAlt = mobileThumbnail.dataset.alt || '';
        mainImage.src = selectedImage;
        mainImage.alt = selectedAlt;
        mainImage.dataset.selectedImage = selectedImage;
        mainImage.dataset.selectedAlt = selectedAlt;
        document.querySelectorAll('[data-gallery-thumb]').forEach((item) => item.setAttribute('aria-current', item.dataset.index === index ? 'true' : 'false'));
        document.querySelectorAll('[data-gallery-mobile-thumb]').forEach((item) => item.setAttribute('aria-current', item === mobileThumbnail ? 'true' : 'false'));
      }
      return;
    }
    const link = event.target.closest('.product-review-link');
    if (!link) return;
    const target = document.getElementById('ProductReviews');
    if (!target) return;
    event.preventDefault();
    history.pushState(null, '', link.getAttribute('href'));
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
    window.setTimeout(() => target.focus({ preventScroll: true }), reduceMotion ? 0 : 450);
  });
})();
